module.exports = __webpack_public_path__ + "static/img/park1 (2).5273dbbd.jpg";